import React from 'react';
import { worryDecides } from '../data/content';
export function WhyItMatters() {
  return <section className="bg-ink py-12 text-cream lg:py-20" data-id="element-262" data-mp="2txv6va48ixc9">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-263" data-mp="2tv8y575lybsg">
        <h2 className="font-display text-[34px] leading-tight sm:text-[48px]" data-id="element-264" data-mp="2fyvt4xi9g2uv">Anxiety Doesn’t Outgrow Itself.</h2>
        <p className="mt-4 text-balance font-display text-[22px] italic leading-snug text-gold sm:text-[28px]" data-id="element-265" data-mp="2kx7112ozw3ag">
          Without the right tools, avoidance becomes a habit and worry becomes a worldview.
        </p>

        <div className="mx-auto mt-8 max-w-xl space-y-1 text-[17px] leading-relaxed text-cream/80" data-id="element-266" data-mp="3cpxp2pwiylom">
          <p data-id="element-267" data-mp="2yuc5iy928u3l">Reassurance can bring relief in the moment.</p>
          <p data-id="element-268" data-mp="33uhsw28arufv">Avoidance can make the scary thing disappear for today.</p>
          <p className="pt-2 font-medium text-cream" data-id="element-269" data-mp="3rkkfi2tg0873">
            But neither one automatically teaches your child what to do the next time worry shows up.
          </p>
        </div>

        <p className="mt-8 text-[17px] text-cream/80" data-id="element-270" data-mp="oz2updmb1dr9">And when worry repeatedly gets to decide:</p>
        <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-271" data-mp="kxhmi5kptnne">
          {worryDecides.map(line => <li key={line} className="rounded-full bg-cream/10 px-4 py-2 text-[15px] italic text-cream" data-id="element-272" data-mp="yomeclhudbn6">
              “{line}”
            </li>)}
        </ul>
        <p className="mx-auto mt-4 max-w-xl text-[17px] leading-relaxed text-cream/80" data-id="element-273" data-mp="tw2zll7f4ags">
          it can become harder for a child to discover what they are actually capable of handling.
        </p>

        <div className="mx-auto mt-8 max-w-xl border-t border-cream/15 pt-8" data-id="element-274" data-mp="13q3bc5x7gdyh">
          <p className="text-[17px] leading-relaxed text-cream/80" data-id="element-275" data-mp="1hn8fu1h9t4rm">The answer isn’t to force them through fear.</p>
          <p className="text-[17px] leading-relaxed text-cream/80" data-id="element-276" data-mp="1cmkofep4qlwv">And it isn’t to remove every uncomfortable feeling for them.</p>
          <p className="mt-3 font-display text-[22px] leading-snug text-sage sm:text-[26px]" data-id="element-277" data-mp="3ega8k95h0q2a">
            It’s helping them build the skills to move through worry one manageable step at a time.
          </p>
        </div>
      </div>
    </section>;
}